import { useCallback, useState } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import LogoutIcon from '@/material-icons/400-24px/logout.svg?react';
import SyncAltIcon from '@/material-icons/400-24px/sync_alt.svg?react';
import { openModal } from 'mastodon/actions/modal';
import { Icon } from 'mastodon/components/icon';
import { useAppDispatch } from 'mastodon/store';

import { SwitchAccountBubble } from './switch_account_bubble';
import classes from './switch_account_bubble.module.scss';

const messages = defineMessages({
  logout: { id: 'navigation_bar.logout', defaultMessage: 'Logout' },
  switchAccount: {
    id: 'navigation_bar.switch_account',
    defaultMessage: 'Switch account',
  },
});

/**
 * Switching account and logging out, as sidebar items under Preferences.
 * They were the last items of Mastodon's "More" menu, which this server
 * does not show.
 */
export const AccountLinks: React.FC = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  // The accounts open in a bubble beside the item, not a modal
  const [switchButton, setSwitchButton] = useState<HTMLButtonElement | null>(
    null,
  );
  // The bubble points at the item's icon and words, not the whole row
  const [switchLabel, setSwitchLabel] = useState<HTMLSpanElement | null>(null);
  const [switching, setSwitching] = useState(false);

  const handleSwitchAccountClick = useCallback(() => {
    setSwitching((value) => !value);
  }, []);

  const handleSwitchClose = useCallback(() => {
    setSwitching(false);
  }, []);

  const handleLogoutClick = useCallback(() => {
    dispatch(openModal({ modalType: 'CONFIRM_LOG_OUT', modalProps: {} }));
  }, [dispatch]);

  return (
    <>
      <li>
        <button
          ref={setSwitchButton}
          className='column-link column-link--transparent'
          type='button'
          onClick={handleSwitchAccountClick}
          aria-expanded={switching}
        >
          <span ref={setSwitchLabel} className={classes.label}>
            <Icon id='' icon={SyncAltIcon} className='column-link__icon' />
            {intl.formatMessage(messages.switchAccount)}
          </span>
        </button>

        {switching && (
          <SwitchAccountBubble
            reference={switchLabel}
            trigger={switchButton}
            onClose={handleSwitchClose}
          />
        )}
      </li>
      <li>
        <button
          className='column-link column-link--transparent'
          type='button'
          onClick={handleLogoutClick}
        >
          <Icon id='' icon={LogoutIcon} className='column-link__icon' />
          {intl.formatMessage(messages.logout)}
        </button>
      </li>
    </>
  );
};
